var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-view-template',{on:{"userLogin":_vm.handleUserLogin}})
}
var staticRenderFns = []

export { render, staticRenderFns }